__turbopack_context__.v({
  "blocksBackgroundColor": "GalleryBlock-module-scss-module__W3hw6W__blocksBackgroundColor",
  "blocksFontColor": "GalleryBlock-module-scss-module__W3hw6W__blocksFontColor",
  "contentContainer": "GalleryBlock-module-scss-module__W3hw6W__contentContainer",
  "coverImageContainer": "GalleryBlock-module-scss-module__W3hw6W__coverImageContainer",
  "editButton": "GalleryBlock-module-scss-module__W3hw6W__editButton",
  "galleryItem": "GalleryBlock-module-scss-module__W3hw6W__galleryItem",
  "imageWrapper": "GalleryBlock-module-scss-module__W3hw6W__imageWrapper",
  "imageWrapperHidden": "GalleryBlock-module-scss-module__W3hw6W__imageWrapperHidden",
  "item": "GalleryBlock-module-scss-module__W3hw6W__item",
  "photoDescription": "GalleryBlock-module-scss-module__W3hw6W__photoDescription",
  "placeholderDiv": "GalleryBlock-module-scss-module__W3hw6W__placeholderDiv",
  "placeholderDivHidden": "GalleryBlock-module-scss-module__W3hw6W__placeholderDivHidden",
  "secondaryNavBackgroundColor": "GalleryBlock-module-scss-module__W3hw6W__secondaryNavBackgroundColor",
  "sliderWrapper": "GalleryBlock-module-scss-module__W3hw6W__sliderWrapper",
  "sliderWrapperSingle": "GalleryBlock-module-scss-module__W3hw6W__sliderWrapperSingle",
  "themeBackgroundColor": "GalleryBlock-module-scss-module__W3hw6W__themeBackgroundColor",
  "themeFontColor": "GalleryBlock-module-scss-module__W3hw6W__themeFontColor",
  "themeFontFamily": "GalleryBlock-module-scss-module__W3hw6W__themeFontFamily",
  "transitionEnter": "GalleryBlock-module-scss-module__W3hw6W__transitionEnter",
  "transitionEnterActive": "GalleryBlock-module-scss-module__W3hw6W__transitionEnterActive",
  "transitionEnterDone": "GalleryBlock-module-scss-module__W3hw6W__transitionEnterDone",
  "transitionExit": "GalleryBlock-module-scss-module__W3hw6W__transitionExit",
  "transitionExitActive": "GalleryBlock-module-scss-module__W3hw6W__transitionExitActive",
  "transitionExitDone": "GalleryBlock-module-scss-module__W3hw6W__transitionExitDone",
});
